export type Specialties = {
  id: string;
  isTop: boolean;
  specialty: Specialty[];
};

export interface Specialty {
  id: string;
  isTop?: boolean;
  name: string;
  commonalityOrder?: number | null;
  concernCategory?: SpecialtyConcernCategoryEnum;
}

export type UserSpecialty = {
  id: string;
  userId: string;
  specialtyId: string;
  isTop: boolean;
  name: string;
  commonalityOrder?: number | null;
};

export const enum SpecialtyConcernCategoryEnum {
  general = 'general',
  specific = 'specific',
}